/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	// VIPR
	'./definitions/providers/VIPR3Provider',
	'./definitions/providers/LocalProvider',
	'./vipr/VIPR',
	'./vipr/properties/VIPRProperties',

	'./recommender/BaseSmartsVisRecommenderWrapper',
	'./recommender/SmartsRecommenderService',

	// VisViews and controllers
	'./renderer/vipr3/VIPRView',
	'./renderer/summary/control/SummaryControl',
	'./renderer/summary/SummaryProxyView',
	'./renderer/infographic/InfographicView',
	'./renderer/crosstab/CrosstabView',
	'./renderer/crosstab/CrosstabControl',
	'./renderer/grid/GridView',
	'./renderer/grid/control/JQGrid',
	'./renderer/indentedlist/IndentedListView',
	'./renderer/indentedlist/control/IndentedListControl',
	'./renderer/dataplayer/DataPlayerView',
	'./renderer/kpi/KpiView',
	'./renderer/kpi/control/KpiControl',
	'./renderer/infographic/control/InfographicControl',

	// render seqeunce tasks
	'./renderer/sequence/DataTask',
	'./renderer/sequence/HighlighterTask',
	'./renderer/sequence/RenderTask',
	'./renderer/sequence/ResultsDataReaderTask',
	'./renderer/sequence/SetDataTask',
	'./renderer/sequence/VisControlTask',
	'./renderer/sequence/VisSpecTask',
	'./renderer/sequence/VisViewTask',

	// slot actions
	'./interactions/FilterAction'
], function() {
	'use strict';
});
